import {Component, h, Host, Method, Prop} from '@stencil/core';
import axios from "../../../utils/get-axios";

const ACC = (window as any).ACC;

@Component({
    tag: 'lilu-rating-container',
    styleUrl: 'lilu-rating-container.scss',
    shadow: true
})
export class LiluRatingContainer {

  @Prop() CSRFToken?: any;
  @Prop() avarage: number;
  @Prop() productId: number;
  @Prop() pageIndex = 1;
  @Prop() initialLoadCount = 5;
  @Prop() totalAmount: number;
  @Prop() commentelements;
  @Prop() starCount = 0;
  @Prop() showMoreButton = true;
  @Prop() showResetButton = false;
  @Prop() showMoreSteps = 10;
  @Prop() loadeMoreText = "mehr laden";
  @Prop() resetText = "alle einklappen";
  @Prop() ratingsTextOne: string;
  @Prop() ratingsTextTwo: string;
  @Prop() ratingsTextThree: string;
  @Prop() ratingsTextFour: string;
  @Prop() ratingsTextFive: string;
  @Prop() showAllText ="ALLE BEWERTUNGEN ANZEIGEN"

  @Method()
  async loadRatings() {
    const self = this; //because you're out of the 'this' context within the call

    axios.post(`${location.protocol}//${location.host + location.pathname}/reviewhtml/${this.starCount}?pageNumber=${this.pageIndex}`,
      '',
      {
        headers: {
          CSRFToken: ACC.config.CSRFToken,
        },
      }
    ).then(function (response) {
      if(self.pageIndex === 1) {
        self.commentelements = response.data.panelHtml;
        self.totalAmount = response.data.totalAmount;
        if(self.initialLoadCount < self.totalAmount) {
          self.showMoreButton = true;
        } else {
          self.showMoreButton = false;
        }
        self.showResetButton = false;
      } else {
        self.commentelements += response.data.panelHtml;
      }

    });
  }

  getComments: any = () => {
    return <div innerHTML={this.commentelements}></div>;
  };

  loadMoreComments() {
    if(this.pageIndex * this.showMoreSteps + this.initialLoadCount >= this.totalAmount) {
      this.showMoreButton = false;
    }

    if(this.initialLoadCount < this.totalAmount && this.pageIndex * this.showMoreSteps + this.initialLoadCount >= this.totalAmount) {
      this.showResetButton = true;
    } else {
      this.showResetButton = false;
    }

    this.pageIndex ++;
    this.loadRatings();
  }

  resetComments() {
      this.pageIndex = 1;
      this.loadRatings();
  }

  filterRatings(event, starCount) {
    event.preventDefault();
    this.starCount = starCount;
    this.pageIndex = 1;
    this.loadRatings();
  }

  componentWillLoad() {
    this.loadRatings();
  }

  componentDidLoad() {
    if (ACC !== undefined) {
      this.CSRFToken = ACC.config.CSRFToken;
    }
  }

    render() {
        return (
            <Host class='size-20'>
                <section id="rating-area" class="rating-container">
                    <slot name="title"></slot>
                    <lilu-hr></lilu-hr>

                    <div class="rating-overview">
                        <div class="rating-details">
                            <div class="average">
                                <span class="average-icon">Ø</span>
                                <span class="average-number">{this.avarage}</span>
                            </div>
                            <lilu-rating rating={this.avarage} color="nero"></lilu-rating>

                            <lilu-link
                              color="dark"
                              appearance="uppercase underline"
                              size="size-12 lg-size-14"
                              font="regular"
                              class="rating-comment-link"
                              onClick={(e) => this.filterRatings(e, 0)}
                            >
                              { this.showAllText }
                            </lilu-link>

                            <slot name="rating-button"></slot>
                        </div>
                        <div class="rating-list">
                            <div class="rating-list-item">
                                <lilu-rating rating={5} color="nero"></lilu-rating>
                                <lilu-link
                                  slot="rating-link-5"
                                  color="dark"
                                  appearance="uppercase underline"
                                  size="size-12 lg-size-14"
                                  font="regular"
                                  onClick={(e) => this.filterRatings(e, 5)}
                                >
                                  { this.ratingsTextFive }
                                </lilu-link>
                            </div>
                            <div class="rating-list-item">
                                <lilu-rating rating={4} color="nero"></lilu-rating>
                                <lilu-link
                                  color="dark"
                                  appearance="uppercase underline"
                                  size="size-12 lg-size-14"
                                  font="regular"
                                  onClick={(e) => this.filterRatings(e, 4)}
                                >
                                  { this.ratingsTextFour }
                                </lilu-link>
                            </div>
                            <div class="rating-list-item">
                                <lilu-rating rating={3} color="nero"></lilu-rating>
                                <lilu-link
                                  color="dark"
                                  appearance="uppercase underline"
                                  size="size-12 lg-size-14"
                                  font="regular"
                                  onClick={(e) => this.filterRatings(e, 3)}
                                >
                                  { this.ratingsTextThree }
                                </lilu-link>
                            </div>
                            <div class="rating-list-item">
                                <lilu-rating rating={2} color="nero"></lilu-rating>
                                <lilu-link
                                  color="dark"
                                  appearance="uppercase underline"
                                  size="size-12 lg-size-14"
                                  font="regular"
                                  onClick={(e) => this.filterRatings(e, 2)}
                                >
                                  { this.ratingsTextTwo }
                                </lilu-link>
                            </div>
                            <div class="rating-list-item">
                                <lilu-rating rating={1} color="nero"></lilu-rating>
                                <lilu-link
                                  color="dark"
                                  appearance="uppercase underline"
                                  size="size-12 lg-size-14"
                                  font="regular"
                                  onClick={(e) => this.filterRatings(e, 1)}
                                >
                                  { this.ratingsTextOne }
                                </lilu-link>
                            </div>
                        </div>
                    </div>
                    <div class="comment">
                      { this.getComments() }
                    </div>
                  { this.showMoreButton ?
                    <lilu-button type='primary'
                                 appearance='outline'
                                 height='h-lg'
                                 width='w-mobile-full-width'
                                 fontsize="size-18"
                                 font='semibold'
                                 transform='uppercase'
                                 onClick={() => this.loadMoreComments()}
                    >
                      { this.loadeMoreText }
                    </lilu-button>
                  :
                      ''
                  }
                  { this.showResetButton ?
                    <lilu-button type='primary'
                                 appearance='outline'
                                 height='h-lg'
                                 width='w-mobile-full-width'
                                 fontsize="size-18"
                                 font='semibold'
                                 transform='uppercase'
                                 onClick={() => this.resetComments()}
                    >
                      { this.resetText }
                    </lilu-button>
                  :
                     ''
                  }
                </section>
            </Host>
        );
    }
}
